"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Eip6963Provider {
    constructor() {
        this.providers = [];
        this.getProviders();
    }
    getProvider(name) {
        return this.providers.find(p => p.info.name === name);
    }
    getProviders() {
        let providers = [];
        function onAnnouncement(event) {
            // Prevent adding a provider if it already exists in the list based on its uuid.
            if (providers.some(p => p.info.uuid === event.detail.info.uuid))
                return;
            providers = [...providers, event.detail];
        }
        window.addEventListener("eip6963:announceProvider", onAnnouncement);
        window.dispatchEvent(new Event("eip6963:requestProvider"));
        this.providers = providers;
    }
}
exports.default = Eip6963Provider;
